import { useEffect } from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { FlexGrid, Typography } from '@albo-ui/core';
import { RecentActorsOutlined, ExpandMore } from "@mui/icons-material";
import { customStyles2 } from '../../../util/TableStyles';
import { noDataComponent } from '../../../util/DataObject';
import { useCRMAnalist } from './hooks/useCRMAnalist';
import DataTable from 'react-data-table-component';
import moment from 'moment';
moment.locale('es');

export const CRMAnalistsAdmin = ({changeAlert, changeLoader, crmType}: any) => {
    const { loading: loadingTable, columns, configAgent, expanded, role, changeExpanded } = useCRMAnalist(changeAlert, crmType)

    useEffect(() => {
        changeLoader(loadingTable)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable]);

    return (
        <FlexGrid style={{display: 'block'}} container fullWidth >
			<Accordion sx={{width: '100% !important', mb: 2}} expanded={expanded} onChange={changeExpanded}>
				<AccordionSummary aria-controls="list-agents" id="list-agents-compliance-analyst" expandIcon={<ExpandMore/>} sx={{mx: 2.3, "& .Mui-expanded": {display: 'grid'}}}>
					<Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}}>
                        <RecentActorsOutlined sx={{ marginRight: 1 }}/> {role}
					</Typography>

                    {expanded && <Typography variant="paragraph" style={{alignItems: "center"}}>
                        Administrador de asignaciones
					</Typography>}
				</AccordionSummary>
				<AccordionDetails>
					<FlexGrid container direction="column">
                        <DataTable
                            columns={columns}
                            data={configAgent}
                            customStyles={customStyles2}
                            noDataComponent={noDataComponent} 
                            fixedHeader
                        />
					</FlexGrid>	
				</AccordionDetails>
			</Accordion>
        </FlexGrid>
    );
};
